module.exports = __webpack_public_path__ + "static/media/undraw_updated_resume_re_q1or.394a8666.svg";